/* angular:styles/component:css;4f4c154e6abf2cb1674526e2768958de40e70baba46f81515e84e4e588553dcd;C:\Users\Copyfly\Desktop\Desarrollo\copisteria-app-ionic-ng19\src\app\components\whatsapp-fab\whatsapp-fab.component.ts */
.whatsapp-fab {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 2000;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
  cursor: pointer;
}
.whatsapp-fab:hover {
  transform: scale(1.08);
}
.whatsapp-fab img {
  display: block;
}
/*# sourceMappingURL=whatsapp-fab.component-LLYY5OTW.css.map */
